import { requestGet } from '../utils/requestApi'

export async function getFaqList (payload){
  return requestGet('faq', payload)
}